/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaginatedRiskList,
  PaginatedVIPProfileList,
  PatchedRisk,
  PatchedVIPProfile,
  Risk,
  RisksMetadata200Response,
  RisksStatistics200Response,
  VIPProfile,
} from '../models/index';
import {
    PaginatedRiskListFromJSON,
    PaginatedRiskListToJSON,
    PaginatedVIPProfileListFromJSON,
    PaginatedVIPProfileListToJSON,
    PatchedRiskFromJSON,
    PatchedRiskToJSON,
    PatchedVIPProfileFromJSON,
    PatchedVIPProfileToJSON,
    RiskFromJSON,
    RiskToJSON,
    RisksMetadata200ResponseFromJSON,
    RisksMetadata200ResponseToJSON,
    RisksStatistics200ResponseFromJSON,
    RisksStatistics200ResponseToJSON,
    VIPProfileFromJSON,
    VIPProfileToJSON,
} from '../models/index';

export interface RisksListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    profile?: number;
    search?: string;
    severity?: string;
    source?: string;
    status?: string;
    type?: string;
}

export interface RisksMetadataRequest {
    teamSlug: string;
    profile?: number;
}

export interface RisksRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface RisksStatisticsRequest {
    teamSlug: string;
    profile?: number;
}

export interface VipProfilesCreateRequest {
    teamSlug: string;
    vIPProfile: Omit<VIPProfile, 'id'|'team'|'risk_count'|'active_risks'>;
}

export interface VipProfilesDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface VipProfilesListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface VipProfilesPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedVIPProfile?: Omit<PatchedVIPProfile, 'id'|'team'|'risk_count'|'active_risks'>;
}

export interface VipProfilesRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface VipProfilesUpdateRequest {
    id: string;
    teamSlug: string;
    vIPProfile: Omit<VIPProfile, 'id'|'team'|'risk_count'|'active_risks'>;
}

export interface VipRisksCreateRequest {
    teamSlug: string;
    risk: Omit<Risk, 'id'|'profile_name'|'created_at'|'updated_at'>;
}

export interface VipRisksDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface VipRisksPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedRisk?: Omit<PatchedRisk, 'id'|'profile_name'|'created_at'|'updated_at'>;
}

export interface VipRisksUpdateRequest {
    id: string;
    teamSlug: string;
    risk: Omit<Risk, 'id'|'profile_name'|'created_at'|'updated_at'>;
}

/**
 * 
 */
export class VipApi extends runtime.BaseAPI {

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async risksListRaw(requestParameters: RisksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedRiskList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling risksList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['profile'] != null) {
            queryParameters['profile'] = requestParameters['profile'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['severity'] != null) {
            queryParameters['severity'] = requestParameters['severity'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/risks/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedRiskListFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async risksList(requestParameters: RisksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedRiskList> {
        const response = await this.risksListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns unique lists of sources, types, and domains from risks associated with VIP profiles in the current team.  Can be filtered by profile_id to show only metadata for risks related to a specific VIP profile.
     */
    async risksMetadataRaw(requestParameters: RisksMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RisksMetadata200Response>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling risksMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['profile'] != null) {
            queryParameters['profile'] = requestParameters['profile'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/risks/metadata/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RisksMetadata200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns unique lists of sources, types, and domains from risks associated with VIP profiles in the current team.  Can be filtered by profile_id to show only metadata for risks related to a specific VIP profile.
     */
    async risksMetadata(requestParameters: RisksMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RisksMetadata200Response> {
        const response = await this.risksMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async risksRetrieveRaw(requestParameters: RisksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Risk>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling risksRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling risksRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/risks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RiskFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async risksRetrieve(requestParameters: RisksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Risk> {
        const response = await this.risksRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns statistics about risks including: - Counts grouped by severity - Counts grouped by source - Counts grouped by status  Can be filtered by profile_id to show only statistics for risks related to a specific VIP profile.
     */
    async risksStatisticsRaw(requestParameters: RisksStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RisksStatistics200Response>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling risksStatistics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['profile'] != null) {
            queryParameters['profile'] = requestParameters['profile'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/risks/statistics/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RisksStatistics200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns statistics about risks including: - Counts grouped by severity - Counts grouped by source - Counts grouped by status  Can be filtered by profile_id to show only statistics for risks related to a specific VIP profile.
     */
    async risksStatistics(requestParameters: RisksStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RisksStatistics200Response> {
        const response = await this.risksStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesCreateRaw(requestParameters: VipProfilesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VIPProfile>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipProfilesCreate().'
            );
        }

        if (requestParameters['vIPProfile'] == null) {
            throw new runtime.RequiredError(
                'vIPProfile',
                'Required parameter "vIPProfile" was null or undefined when calling vipProfilesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/profiles/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VIPProfileToJSON(requestParameters['vIPProfile']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VIPProfileFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesCreate(requestParameters: VipProfilesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VIPProfile> {
        const response = await this.vipProfilesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesDestroyRaw(requestParameters: VipProfilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vipProfilesDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipProfilesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/profiles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesDestroy(requestParameters: VipProfilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vipProfilesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesListRaw(requestParameters: VipProfilesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedVIPProfileList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipProfilesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/profiles/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedVIPProfileListFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesList(requestParameters: VipProfilesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedVIPProfileList> {
        const response = await this.vipProfilesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesPartialUpdateRaw(requestParameters: VipProfilesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VIPProfile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vipProfilesPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipProfilesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/profiles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedVIPProfileToJSON(requestParameters['patchedVIPProfile']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VIPProfileFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesPartialUpdate(requestParameters: VipProfilesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VIPProfile> {
        const response = await this.vipProfilesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesRetrieveRaw(requestParameters: VipProfilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VIPProfile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vipProfilesRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipProfilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/profiles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VIPProfileFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesRetrieve(requestParameters: VipProfilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VIPProfile> {
        const response = await this.vipProfilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesUpdateRaw(requestParameters: VipProfilesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VIPProfile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vipProfilesUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipProfilesUpdate().'
            );
        }

        if (requestParameters['vIPProfile'] == null) {
            throw new runtime.RequiredError(
                'vIPProfile',
                'Required parameter "vIPProfile" was null or undefined when calling vipProfilesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/profiles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VIPProfileToJSON(requestParameters['vIPProfile']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VIPProfileFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipProfilesUpdate(requestParameters: VipProfilesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VIPProfile> {
        const response = await this.vipProfilesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipRisksCreateRaw(requestParameters: VipRisksCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Risk>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipRisksCreate().'
            );
        }

        if (requestParameters['risk'] == null) {
            throw new runtime.RequiredError(
                'risk',
                'Required parameter "risk" was null or undefined when calling vipRisksCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/risks/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RiskToJSON(requestParameters['risk']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RiskFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipRisksCreate(requestParameters: VipRisksCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Risk> {
        const response = await this.vipRisksCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipRisksDestroyRaw(requestParameters: VipRisksDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vipRisksDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipRisksDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/risks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipRisksDestroy(requestParameters: VipRisksDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vipRisksDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipRisksPartialUpdateRaw(requestParameters: VipRisksPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Risk>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vipRisksPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipRisksPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/risks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedRiskToJSON(requestParameters['patchedRisk']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RiskFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipRisksPartialUpdate(requestParameters: VipRisksPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Risk> {
        const response = await this.vipRisksPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipRisksUpdateRaw(requestParameters: VipRisksUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Risk>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vipRisksUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling vipRisksUpdate().'
            );
        }

        if (requestParameters['risk'] == null) {
            throw new runtime.RequiredError(
                'risk',
                'Required parameter "risk" was null or undefined when calling vipRisksUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/vip/{team_slug}/risks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RiskToJSON(requestParameters['risk']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RiskFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing risks associated with VIP profiles. Supports CRUD operations with team-based access control.
     */
    async vipRisksUpdate(requestParameters: VipRisksUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Risk> {
        const response = await this.vipRisksUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
